"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HomeAccordion = void 0;
var _Accordion = _interopRequireDefault(require("01_core/components/layout/Accordion"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _SuggestBox = _interopRequireDefault(require("01_core/components/materials/SuggestBox"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GRID_SPACING = 1;

/**
 * 個人情報設定 自宅場所
 */
class HomeAccordion extends _react.default.Component {
  render() {
    const {
      setEntry,
      getCodeItems,
      getCodeName,
      intl,
      entries
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Accordion.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_HOME_PLACE
      }),
      help: /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
        id: _labelConsts.LABEL.USERCUSTOM_HOMEPLACE_HELP
      }),
      subTitle: entries.homeRenkeiFlg ? intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_LINKAGE_PERSONAL
      }) : entries.masterFlg ? intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_LINKAGE_MASTER_DATA
      }) : ''
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: GRID_SPACING
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, entries.homeRenkeiFlg || entries.masterFlg ? /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TDFK
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(getCodeName(_CodeConsts.CODE.TDFK.KBN, entries.homeTdfkCd)))) : /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TDFK
      })
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: GRID_SPACING
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12,
        sm: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      value: entries.homeTdfkCd,
      onChange: setEntry('homeTdfkCd'),
      items: getCodeItems(_CodeConsts.CODE.TDFK.KBN, undefined, ['0'])
    }))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_UPDATE_DATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.homeUpdDt))))));
  }
}
exports.HomeAccordion = HomeAccordion;
HomeAccordion.propTypes = {
  // Parent
  setEntry: _propTypes.default.func,
  // withCodeUtil
  getCodeItems: _propTypes.default.func,
  getCodeName: _propTypes.default.func,
  intl: _propTypes.default.object,
  // State
  entries: _propTypes.default.object
};
const mapStateToProps = state => {
  return {
    entries: state.personalRegister.entries
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)((0, _CodeUtil.withCodeUtil)(HomeAccordion));